"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const IconSizes_1 = require("../Icons/PropTypes/IconSizes");
const Icons_1 = require("../Icons");
const useTranslations_1 = require("../hooks/useTranslations");
const DropzoneErrors = ({ stateErrors, otherErrors, errorsLabel, errorMessages, setErrors }) => {
    const t = (0, useTranslations_1.useGlobalTranslations)();
    const removeErrors = () => {
        setErrors([...stateErrors]);
    };
    const getErrorMessage = (err) => {
        const { code, file } = Object.assign({ file: undefined }, err);
        let errorMessage = "";
        if (errorMessages[code]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            errorMessage = errorMessages[code](file);
        }
        return errorMessage;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        stateErrors.length > 0 && (react_1.default.createElement("div", { className: "dropzone-errors dropzone-state-errors" },
            react_1.default.createElement("ul", null, stateErrors.map((error, index) => (react_1.default.createElement("li", { key: index }, getErrorMessage(error))))))),
        otherErrors.length > 0 && (react_1.default.createElement("div", { className: "dropzone-errors dropzone-other-errors" },
            react_1.default.createElement("div", null,
                errorsLabel && react_1.default.createElement("span", { className: "dropzone-errors-label" }, errorsLabel),
                react_1.default.createElement("ul", null, otherErrors.map((error, index) => (react_1.default.createElement("li", { key: index }, getErrorMessage(error)))))),
            react_1.default.createElement("button", { onClick: removeErrors, "aria-label": t("close") },
                react_1.default.createElement(Icons_1.CancelIcon, { "aria-hidden": true, size: IconSizes_1.IconSizes.Xsmall }))))));
};
exports.default = DropzoneErrors;
//# sourceMappingURL=DropzoneErrors.js.map